/* eslint-disable react-redux/useSelector-prefer-selectors */
import React from 'react';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import AssemblySection from 'pcb-assembly/components/Assembly';
import PartsSection from 'pcb-parts/Parts';
import FabricationSection from 'pcb-fabrication/components/Fabrication';
import { TAB_ASSEMBLY, TAB_FABRICATION, TAB_PCB_PARTS } from 'project_quote/data/tabTypes';
import { changeSummaryItemColor } from 'pu-utils/tab_controller';
import { useDispatch, useSelector } from 'react-redux';
import { changeTab } from 'project_quote/data/ProjectSlice';
import { processTabChange } from 'pcb-parts/slice/process_tab_change';

const getItemSection = (item) => {
  switch (item.code) {
    case TAB_ASSEMBLY:
      return <AssemblySection itemId={item.id} />;
    case TAB_PCB_PARTS:
      return <PartsSection itemId={item.id} />;
    case TAB_FABRICATION:
      return <FabricationSection itemId={item.id} />;
    default:
      return null;
  }
};

const ProjectItems = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.project.activeTab);

  const onSelect = (tab) => {
    if (tab !== activeTab) {
      dispatch(changeTab(tab));
      dispatch(processTabChange(tab));
      changeSummaryItemColor(tab);
    }
  }

  return (
    <div className="container-fluid container-lg px-2 px-lg-0" id="project-bundle-tabs">
      <Tabs
        id="project-bundle-tabs"
        activeKey={activeTab}
        onSelect={(k) => onSelect(k)}>
        {bundle_items.map((item) => (
          <Tab
            key={item.code}
            eventKey={item.code}
            code={item.code}
            title={item.name}>
            {getItemSection(item)}
          </Tab>
        ))}
      </Tabs>
    </div>
  )
}

export default ProjectItems;